import cn from 'classnames';

import ArticleShareBar from './ArticleShareBar/ArticleShareBar';
import ArticleAuthor from './atoms/ArticleAuthor';

import { Author } from 'types/author';

interface ArticleInfoBarProps {
  className?: string;
  shareBarTitle: string;
  author: Author;
  articleDate: number;
  slug: string;
}
export default function ArticleInfoBar({ className, author, articleDate, slug }: ArticleInfoBarProps) {
  const formattedDate = new Date(articleDate).toLocaleDateString('pl-PL');

  return (
    <div className={cn('flex items-center gap-4 md:block xxxl:flex', className)}>
      <div className="items-left mb-4 flex flex-shrink-0 flex-col xl:mb-0">
        <ArticleAuthor author={author} articleDate={formattedDate} className="mr-2" />
      </div>
      <ArticleShareBar slug={slug} className="hidden flex-shrink-0 sm:flex" />
    </div>
  );
}
